export default "dist/images/components-image-shape-control-default.5e465f6.png";